/* @flow strict */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';
import moment from 'moment';

export const columns = (modalToggleCallback: (boolean, {}) => void, handleToggleSchStatus: () => void): [] => {
  return [
      {
          selector: 'status',
          name: 'Status',
          sortable: false,
          cell: (row: {}): React.Element<'div'> => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              {row.status === 'Completed' ? // 05/08/2020 05:00
                <>
                  Sent {row.complete_time_utc && moment(row.complete_time_utc).format('MM/DD/YYYY hh:mm a')}
                </> :
                <>
                  <Switcher
                    className='form-switcher-sm'
                    id={row.id}
                    name={row.id}
                    index={row.id}
                    checked={row.status !== 'Off'}
                    onCallback={async (e: SyntheticEvent<HTMLInputElement>, status: boolean) => {
                      await handleToggleSchStatus(
                        row.id,
                        !!status ? 'Scheduled' : 'Off'
                      );
                    }}
                  />
                  <span style={{ marginLeft: '1rem' }}>{row.status}</span>
                </>
              }
            </div>
          )
      },
      {
          selector: 'name',
          name: 'Name',
          sortable: false
      },
      {
          selector: 'subject',
          name: 'Email Subject',
          sortable: false,
          cell: (row: {}): string => {
            if ((row.type === 'Customize' || row.type === 'Recent') && row.status !== 'Completed') {
              return (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    modalToggleCallback(true, row);
                  }}
                >{row.subject}</a>
              );
            }

            return row.subject;
          }
      },
      {
          selector: 'recipient_type',
          name: 'Recipient',
          sortable: false,
          cell: (row: {}): string => {
            switch (row.recipient_type) {
              case 'AllAttendees':
                return 'Attendee';
              case 'TicketType':
                return '';
              default:
                return row.recipient_type;
            }
          }
      },
      {
         selector: 'type',
         name: 'Schedule',
         sortable: false
      }
    ];
};
